/**
 * Top navigation configuration
 */

import { validRoles as healthcheckRoles } from "../healthcheck";

const roleSelectorRoles = ["ROLE_ADMIN", "ROLE_ALTEGRA_STAFF"];
const paramSettingsRoles = [
  "ROLE_ADMIN",
  "ROLE_ALTEGRA_STAFF",
  "CHART_REVIEW_ADMIN",
  "CHART_REVIEWER",
];
const hccHierarchiesRoles = ["ROLE_ADMIN", "ROLE_STANDARD"];
const adminToolsRoles = ["ROLE_ADMIN"];

export const routes = [
  {
    path: "/environment",
    label: "Environment",
    icon: "database",
    className: "full-width",
    children: [
      {
        path: "/selection",
        url: "${app.context}/environments",
        label: "Change Environment",
        icon: "database",
      },
    ],
  },
  {
    path: "/tools",
    label: "Tools",
    icon: "wrench",
    children: [
      {
        roles: healthcheckRoles,
        path: "/healthcheck-settings",
        label: "Healthcheck Settings",
        icon: null,
      },
      {
        roles: roleSelectorRoles,
        path: "/role-selector",
        label: "Role Selector",
        icon: "toggle-off",
      },
      {
        path: "/user-report",
        label: "User Report",
        icon: "table",
      },
      {
        roles: paramSettingsRoles,
        path: "/parameter-settings",
        url: "${app.context}/parameter-settings",
        label: "Chart Parameter Settings",
        icon: "table",
      },
      {
        roles: paramSettingsRoles,
        path: "/parameter-type-settings",
        url: "${app.context}/parameter-type-settings",
        label: "Chart Parameter Type Settings",
        icon: "table",
      },
      {
        roles: hccHierarchiesRoles,
        path: "/hcc-disease-hierarchies",
        label: "HCC Disease Hierarchies",
        icon: null,
        data: {
          benefitYear: ["latest", "latest"],
        },
        divider: true,
      },
      {
        path: "/diagnosis-codes",
        label: "Diagnosis Codes",
        icon: "search",
      },
      {
        path: "/procedure-codes",
        label: "Procedure Codes",
        icon: "search",
      },
      {
        path: "/national-drug-codes",
        label: "National Drug Codes",
        icon: "search",
      },
    ],
  },
  {
    roles: adminToolsRoles,
    path: "/admin",
    label: "Admin",
    icon: "gear",
    children: [
      {
        path: "/accounts",
        label: "Accounts",
        icon: "users",
      },
      {
        path: "/event-history",
        label: "Event History",
        icon: "history",
      },
      {
        path: "/config-settings",
        label: "Configuration Settings",
        icon: "gears",
      },
    ],
  },
];

export const userRoutes = {
  path: "/user",
  label: "My Profile",
  icon: "user",
  children: [
    {
      path: "/signout",
      label: "Sign Out",
      icon: "power-off",
      url: "${app.context}/signout",
      divider: true,
    },
  ],
};
